<template>
  <div class="SocialShare dropdown" :class="{ open: this.open }" v-on-clickaway="close">
    <a v-if="link" href="" @click.prevent="toggleOpen" class="btn-toogle">{{ text }}</a>
    <a
      v-else
      @click.prevent="toggleOpen"
      class="SocialShareBtn btn btn-outline-blue btn-toogle items-center text-uppercase h-20 items-center flex justify-center"
    >
      <i class="far fa-paper-plane text-lg mr-2 mt-1" />
      {{ text }}
    </a>
    <div class="SocialShare-Dropdown dropdown-menu dropdown-menu-right">
      <div>
        <a href="" class="SocialShare-Close" @click.prevent="close">
          <i class="fal fa-times pull-right"></i>
        </a>
        <h3 class="text-uppercase text-xl text-center">Share {{ title }}</h3>
        <div class="SocialShare-Links text-center">
          <span v-html="this.facebook"></span>
          <span v-html="this.pinterest"></span>
          <span v-html="this.twitter"></span>
          <span v-html="this.email"></span>
        </div>
        <div class="row mt-20">
          <div class="CopyUrlInput col-xs-9 pr-2">
            <input type="text" class="SocialShare-Url form-control" readonly :value="this.url" />
          </div>
          <div class="CopyUrlBtn col-xs-3 pl-2">
            <button class="btn btn-primary" @click.prevent="copyProfileUrl">Copy</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ClipBoard from "@/lib/ClipBoard"

export default {
  name: "SocialShare",
  props: ["shareText", "useLink", "title", "facebook", "pinterest", "twitter", "email", "url"],
  data() {
    return {
      text: this.shareText || "Share",
      open: false,
      link: this.useLink || false,
    }
  },
  methods: {
    toggleOpen() {
      this.open = !this.open
    },
    close() {
      this.open = false
    },
    copyProfileUrl() {
      var input = $(this)[0].$el.querySelector("input.SocialShare-Url")
      var successful = ClipBoard.copy(document.querySelector(".SocialShareBtn"), $(input).val())
      if (successful) {
        ga("send", "event", "Copylink_SocialShare", "click", $(input).val())
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.SocialShare {
  width: 48%;
  display: inline-block;
  &-Close {
    position: absolute;
    right: 15px;
    top: 8px;
    font-size: 35px;
    color: #fff;
  }
  ::v-deep &-Links {
    margin-top: 30px;
    a {
      font-size: 30px;
      padding: 0 20px;
      color: #fff;

      @media (max-width: 385px) {
        font-size: 20px;
      }
    }
  }
  &-Text {
    font-size: 16px;
  }

  &-Url {
    background-color: #fff;
    color: #d6d6d6;
  }

  .dropdown-menu {
    background-color: #444444;
    color: #fff;
    width: 330px;
    min-height: 250px;
    z-index: 4;
    padding: 25px;

    @media (max-width: 385px) {
      .CopyUrlInput {
        padding-left: 5px;
      }
      .CopyUrlBtn {
        padding-right: 0;
      }
    }

    h3 {
      color: #fff;
      font-weight: 400;
    }
  }
}

.SocialShareBtn {
  width: 100%;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 2px;
  line-height: 17px;
  padding: 17px 0;

  &:hover,
  &:focus {
    color: #fff;
    @apply bg-primary;
  }
}
</style>
